module.exports = __webpack_public_path__ + "static/media/tick-white.71995a2e.svg";